module.exports = __webpack_public_path__ + "img/Cheer Megaphone48.d8212b35.jpg";